// PORTAL Store
import axios from "axios"
import { cacheAdapterEnhancer } from "axios-extensions"

const http = axios.create({
  baseURL: process.env.VUE_APP_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
    //'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    //'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
  },
  adapter: cacheAdapterEnhancer(axios.defaults.adapter)
})

const state = {
  baseURL: process.env.VUE_APP_URL,
  route_Findings: "/findings",
  route_ICD10: "/icd10",

  findingsMetrics: {},

  STATUS: null,
  kioskID: "",
  screenings: [],

  findings: [],
  selectedFindings: {},
  findingsMaxID: 0,
  ICD10: [],
  newFindingID: 7000,

  /////////////////////////////////////
  //  Text        => Finding          /
  //  Title       => Diagnosis        /
  //  SearchLabel => Recommendation   /
  /////////////////////////////////////
  ddValues: {
    //////////////////////////////
    //  EXTERNAL EXAM            /
    //////////////////////////////
    diagExtCommon: [
      {
        value: "Normal",
        title: null,
        searchLabel: null,
        group: null
      },
      {
        value: "Dermatochalasis",
        title: "Dermatochalasis",
        searchLabel: null,
        group: null
      },
      {
        value: "Ptosis",
        title: "Ptosis",
        searchLabel: "Follow-up for Ptosis",
        group: null
      },
      {
        value: "Lid Lesion",
        title: "Lid Lesion",
        searchLabel: "Follow-up for Lid Lesion",
        group: null
      },
      {
        value: "Pterygium",
        title: "Pterygium",
        searchLabel: "Follow-up for Pterygium",
        group: null
      }
    ],
    diagExt: [
      {
        value: "Not Tested",
        title: null,
        searchLabel: null,
        group: "Technical",
        section: "ExternalPhoto"
      },
      {
        value: "Poor Image Quality",
        title: null,
        searchLabel: null,
        group: "Technical",
        section: "ExternalPhoto"
      },
      {
        value: "Lid Retraction",
        title: "Lid Retraction",
        searchLabel: "Follow-up for Lid Retraction",
        group: "External",
        section: "ExternalPhoto"
      },
      {
        value: "Subconj. Hemorrhage",
        title: "Subconj. Hemorrhage",
        searchLabel: "No treatment required",
        group: "External",
        section: "ExternalPhoto"
      },
      {
        value: "Conjunctival Nevus",
        title: "Conjunctival Nevus",
        searchLabel: "Follow for any changes",
        group: "External",
        section: "ExternalPhoto"
      },
      {
        value: "Corneal Scar/Opacity",
        title: "Corneal Scar/Opacity",
        searchLabel: null,
        group: "External",
        section: "ExternalPhoto"
      },
      {
        value: "Iris Nevus",
        title: "Iris Nevus",
        searchLabel: "Follow for any changes",
        group: "External",
        section: "ExternalPhoto"
      },
      {
        value: "Peripheral Iridectomy",
        title: "Peripheral Iridectomy",
        searchLabel: null,
        group: "External",
        section: "ExternalPhoto"
      },
      {
        value: "Iris Neovascularization",
        title: "Iris Neovascularization",
        searchLabel: "Follow-up for Iris Neovascularization",
        group: "External",
        section: "ExternalPhoto"
      },
      {
        value: "Post Synechiae",
        title: "Post Synechiae",
        searchLabel: null,
        group: "External",
        section: "ExternalPhoto"
      },
      {
        value: "Ant Synechiae",
        title: "Ant Synechiae",
        searchLabel: null,
        group: "External",
        section: "ExternalPhoto"
      },
      {
        value: "Cataract",
        title: "Cataract",
        searchLabel: null,
        group: "External",
        section: "ExternalPhoto"
      },
      {
        value: "Esotropia",
        title: "Esotropia",
        searchLabel: "Follow-up for Esotropia",
        group: "External",
        section: "ExternalPhoto"
      },
      {
        value: "Exotropia",
        title: "Exotropia",
        searchLabel: "Follow-up for Exotropia",
        group: "External",
        section: "ExternalPhoto"
      }
    ],

    //////////////////////////////
    //  CORNEAL TOPOGRAPHY       /
    //////////////////////////////
    diagCorCommon: [
      {
        value: "Normal",
        title: null,
        searchLabel: null,
        group: null
      },
      {
        value: "Regular Astigmatism",
        title: "Regular Astigmatism",
        searchLabel: "Follow-up for Regular Astigmatism",
        group: null
      },
      {
        value: "Irregular Astigmatism",
        title: "Irregular Astigmatism",
        searchLabel: "Follow-up for Irregular Astigmatism",
        group: null
      },
      {
        value: "Inferior Steepening/Cone",
        title: "Inferior Steepening/Cone",
        searchLabel: "Follow-up for Inferior Steepening/Cone",
        group: null
      },
      {
        value: "Central Flattening",
        title: "Central Flattening",
        searchLabel: "Follow-up for Central Flattening",
        group: null
      }
    ],
    diagCor: [
      {
        value: "Not Tested",
        title: null,
        searchLabel: null,
        group: "Technical"
      },
      {
        value: "Poor Image Quality",
        title: null,
        searchLabel: null,
        group: "Technical"
      }
      /*
            {
                value: "Corneal Graft Complications",
                title: "Corneal Graft Complications",
                searchLabel: null,
                group: null,
            },
            {
                value: "Amyloid Pterygium",
                title: "Amyloid Pterygium",
                searchLabel: null,
                group: null,
            },
            {
                value: "Double Pterygium",
                title: "Double Pterygium",
                searchLabel: null,
                group: null,
            },
            {
                value: "Stationary Peripheral Pterygium",
                title: "Stationary Peripheral Pterygium",
                searchLabel: null,
                group: null,
            },
            {
                value: "Progressive Peripheral Pterygium",
                title: "Progressive Peripheral Pterygium",
                searchLabel: null,
                group: null,
            },
            {
                value: "Conjunctival Xerosis",
                title: "Conjunctival Xerosis",
                searchLabel: null,
                group: null,
            },
            {
                value: "Pseudopterygium of Conjunctiva",
                title: "Pseudopterygium of Conjunctiva",
                searchLabel: null,
                group: null,
            },
            {
                value: "Mooren's Corneal Ulcer",
                title: "Mooren's Corneal Ulcer",
                searchLabel: null,
                group: null,
            },
            {
                value: "Bullous Keratopathy",
                title: "Bullous Keratopathy",
                searchLabel: null,
                group: null,
            },
            {
                value: "Nodular Corneal Degeneration",
                title: "Nodular Corneal Degeneration",
                searchLabel: null,
                group: null,
            },
            {
                value: "Peripheral Corneal Degeneration",
                title: "Peripheral Corneal Degeneration",
                searchLabel: null,
                group: null,
            },
            {
                value: "Endothelial Corneal Dystrophy",
                title: "Endothelial Corneal Dystrophy",
                group: null,
            },
            {
                value: "Granular Corneal Dystrophy",
                title: "Granular Corneal Dystrophy",
                searchLabel: null,
                group: null,
            },
            */
      //"Normal",
      //"Irregular Astigmatism",
      //"Keratoconus",
      //"Unspecified Pterygium",
      //"Central Pterygium",
      //"Diplopia"
    ],

    ////////////////////////////////
    //  ANTERIOR SEGMENT OCT (PAC) /
    ////////////////////////////////
    diagPacCommon: [
      {
        value: "Normal",
        title: null,
        searchLabel: null,
        group: null
      },
      {
        value: "Narrow Angle",
        title: "Narrow Angle",
        searchLabel: "Follow-up for Narrow Angles/Gonioscopy",
        group: null
      },
      {
        value: "Corneal Thickening",
        title: "Corneal Thickening",
        searchLabel: "Follow-up for Corneal Edema",
        group: null
      },
      {
        value: "Corneal Thinning",
        title: "Corneal Thinning",
        searchLabel: null,
        group: null
      }
      // {
      //   value: "*",
      //   title: "*",
      //   searchLabel: null,
      //   group: null,
      // },
    ],
    diagPac: [
      {
        value: "Not Tested",
        title: null,
        searchLabel: null,
        group: "Technical"
      },
      {
        value: "Poor Image Quality",
        title: null,
        searchLabel: null,
        group: "Technical"
      }
      /*
            {
                value: "Marfan syndrome",
                title: "Marfan syndrome",
                searchLabel: null,
                group: null,
            },
            {
                value: "Fuchs' endothelial dystrophy",
                title: "Fuchs' endothelial dystrophy",
                searchLabel: null,
                group: null,
            },
            {
                value: "Posterior polymorphous dystrophy",
                title: "Posterior polymorphous dystrophy",
                searchLabel: null,
                group: null,
            },
            {
                value: "Terrien's corneal marginal degeneration",
                title: "Terrien's corneal marginal degeneration",
                searchLabel: null,
                group: null,
            },
            {
                value: "Hydroxychloroquine (Plaquenil)",
                title: "Hydroxychloroquine (Plaquenil)",
                searchLabel: null,
                group: null,
            },
            */
      //"Normal",
      //"Corneal Edema",
      //"Corneal Thinning",
      //"Narrow Angle"
      //Bullous Keratopathy",
    ],

    //////////////////////////////
    //  LENS STATUS (OPA)        /
    //////////////////////////////
    diagOpaCommon: [
      {
        value: "Normal",
        title: null,
        searchLabel: null,
        group: null
      },
      {
        value: "Not Tested",
        title: null,
        searchLabel: null,
        group: "Technical"
      },
      {
        value: "Mild Cataract",
        title: "Mild Cataract",
        searchLabel: null,
        group: null
      },
      {
        value: "Moderate Cataract",
        title: "Moderate Cataract",
        searchLabel: "Follow-up to rule out visually significant Cataracts.",
        group: null
      },
      {
        value: "Advanced Cataract",
        title: "Advanced Cataract",
        searchLabel: null,
        group: null
      },
      {
        value: "Pseudophakic",
        title: "Pseudophakic",
        searchLabel: null,
        group: null
      }
    ],
    diagOpa: [
      // {
      //      value: "Not Tested",
      //      title: null,
      //      searchLabel: null,
      //      group: "Technical",
      // },
      {
        value: "Poor Image Quality",
        title: null,
        searchLabel: null,
        group: "Technical"
      }
      //"Normal",
      //"Mild Cataract",
      //"Moderate Cataract",
      //"Advanced Cataract"
      //"Poor Image Quality",
    ],

    //////////////////////////////
    //  FUNDUS PHOTO             /
    //////////////////////////////
    diagFunCommon: [
      {
        value: "Normal",
        title: null,
        searchLabel: null,
        group: null
      },
      {
        value: "Increased Optic N. Cupping",
        title: "Glaucoma Suspect",
        searchLabel: "Follow-up to rule out Glaucoma",
        group: "GLAUCOMA"
      },
      {
        value: "Macular Drusen",
        title: "Macular Drusen",
        searchLabel: "Follow for any signs of progression",
        group: "AMD"
      },
      {
        value: "Mac Epiretinal Membrane",
        title: "Macular Epiretinal Membrane ",
        searchLabel: "Follow-up for an Epiretinal Membrane",
        group: "OTHER"
      },
      {
        value: "A-V Crossing Changes",
        title: "Hypertensive Retinopathy",
        searchLabel: "Follow-up for Hypertensive Retinopathy",
        group: "HYPERTENSIVE"
      }
    ],
    diagFun: [
      {
        value: "Not Tested",
        title: null,
        searchLabel: null,
        group: "Technical"
      },
      {
        value: "Poor Image Quality",
        title: null,
        searchLabel: null,
        group: "Technical"
      },
      {
        value: "Optic Nerve Pallor",
        title: "Optic Nerve Pallor",
        searchLabel: "Follow-up for Optic Nerve Pallor",
        group: "OPTIC NERVE"
      },
      {
        value: "Optic Nerve Swelling",
        title: "Optic Nerve Swelling",
        searchLabel: "Follow-up for Optic Nerve Swelling",
        group: "OPTIC NERVE"
      },
      {
        value: "Splinter Hemorrhage(s)",
        title: "Splinter Hemorrhage",
        searchLabel: "Follow-up for further evaluation",
        group: "OPTIC NERVE"
      },

      {
        value: "Macular Pigment Clumping",
        title: "Macular Pigment Clumping",
        searchLabel: "Follow for any signs of progression",
        group: "AMD"
      },
      {
        value: "Atrophy in Macula",
        title: "Atrophy in Macula",
        searchLabel: "Follow for any signs of progression",
        group: "AMD"
      },
      {
        value: "Pig Cl/Atrophy/Drusen",
        title: "Macular Degeneration",
        searchLabel: "Follow-up Non-Exudative Macular Degeneration",
        group: "AMD"
      },
      {
        value: "Pig Cl/Atrophy/Drusen/Hem",
        title: "Macular Degeneration",
        searchLabel: "Follow-up for Exudative Macular Degeneration: Active",
        group: "AMD"
      },
      {
        value: "Hemorrhage in Macula",
        title: "Hemorrhage in Macula",
        searchLabel: "Follow-up for Exudative Macular Degeneration: Active",
        group: "AMD"
      },

      {
        value: "Dot & Blot Hem’s",
        title: "Probable Diabetic Retinopathy",
        searchLabel: "Follow-up with your doctor to rule out Diabetes",
        group: "DIABETIC"
      },
      {
        value: "Microaneurysms",
        title: "Microaneurysms",
        searchLabel: "Follow-up for further evaluation",
        group: "DIABETIC"
      },
      {
        value: "Exudates in Macula",
        title: "Exudates in Macula",
        searchLabel: "Follow-up for further evaluation",
        group: "DIABETIC"
      },
      {
        value: "Macular Edema",
        title: "Macular Edema",
        searchLabel: "Follow-up for further evaluation and possible treatment",
        group: "DIABETIC"
      },
      {
        value: "D&B Hems/MA’s/Exudates",
        title: "Diabetic Retinopathy",
        searchLabel: "Follow for signs of any progression. Stressed importance of good Diabetic control",
        group: "DIABETIC"
      },
      {
        value: "D&B Hem/MA’s/Exud/Mac Edema",
        title: "Diabetic Retinopathy",
        searchLabel: "Follow-up for treatment",
        group: "DIABETIC"
      },
      {
        value: "Retinal Neovascularization",
        title: "Retinal Neovascularization",
        searchLabel: "Follow-up for treatment",
        group: "DIABETIC"
      },
      {
        value: "D&B Hems/MA’s/Exud/NV",
        title: "Proliferative Diabetic Retinopathy ",
        searchLabel: "Follow-up for treatment",
        group: "DIABETIC"
      },

      {
        value: "Intraretinal Hemorrhage(s)",
        title: "Intraretinal Hemorrhage(s)",
        searchLabel: "Follow-up for further evaluation",
        group: "HYPERTENSIVE"
      },
      {
        value: "Pre-Retinal Hemorrhage",
        title: "Pre-Retinal Hemorrhage",
        searchLabel: "Follow-up for further evaluation",
        group: "HYPERTENSIVE"
      },
      {
        value: "Cotton Wool Spot(s)",
        title: "Cotton Wool Spot(s)",
        searchLabel: "Follow-up for further evaluation",
        group: "HYPERTENSIVE"
      },
      {
        value: "Dilated Blood Vessels",
        title: "Dilated Blood Vessels",
        searchLabel: "Follow-up for further evaluation",
        group: "HYPERTENSIVE"
      },
      {
        value: "Tortuous Blood Vessels",
        title: "Tortuous Blood Vessels",
        searchLabel: "Follow-up for further evaluation",
        group: "HYPERTENSIVE"
      },
      {
        value: "Dilated & Tortuous Vessels",
        title: "Dilated & Tortuous Vessels",
        searchLabel: "Follow-up for further evaluation",
        group: "HYPERTENSIVE"
      },
      {
        value: "Dil/Tort Vess, IRH",
        title: "Vein Occlusion",
        searchLabel: "Follow-up for further evaluation and possible treatment",
        group: "HYPERTENSIVE"
      },
      {
        value: "Dil/Tort Vess, IRH, CWS’s",
        title: "Vein Occlusion",
        searchLabel: "Follow-up for further evaluation and possible treatment",
        group: "HYPERTENSIVE"
      },
      {
        value: "Dil/Tort Vess, IRH, CWS’s, NV",
        title: "Vein Occlusion",
        searchLabel: "Follow-up for treatment",
        group: "HYPERTENSIVE"
      },

      {
        value: "Vitreous Hemorrhage",
        title: "Vitreous Hemorrhage",
        searchLabel: "Follow-up for further evaluation and possible treatment",
        group: "HYPERTENSIVE"
      },

      {
        value: "Choroidal Nevus",
        title: "Choroidal Nevus",
        searchLabel: "Follow for any changes",
        group: "OTHER"
      },
      {
        value: "Retinal Tear",
        title: "Retinal Tear",
        searchLabel: "Follow-up for urgent treatment",
        group: "OTHER"
      },
      {
        value: "Retinal Detachment",
        title: "Retinal Detachment",
        searchLabel: "Follow-up for urgent treatment",
        group: "OTHER"
      },
      {
        value: "Macular Hole",
        title: "Macular Hole",
        searchLabel: "Follow-up for further evaluation and possible treatment",
        group: "OTHER"
      },
      {
        value: "HH Plaque",
        title: "Hollenhurst Plaque",
        searchLabel: "Follow-up with your doctor to rule out Carotid Artery Disease",
        group: "OTHER"
      }
    ],

    //////////////////////////////
    //   Macular OCT             /
    //////////////////////////////
    diagMacCommon: [
      {
        value: "Normal",
        title: null,
        searchLabel: null,
        group: "Technical"
      },
      {
        value: "Macular Drusen",
        title: "Macular Drusen",
        searchLabel: null,
        group: "AMD"
      },
      {
        value: "Retinal Thickening",
        title: null,
        searchLabel: null,
        group: "AMD"
      },
      {
        value: "Retinal Thickening/Cystic",
        title: "Cystoid Macular Edema",
        searchLabel: null,
        group: "EPIRETINAL MEMBRANE"
      },
      {
        value: "Epiretinal Membrane",
        title: "Macular Epiretinal Membrane",
        searchLabel: null,
        group: "EPIRETINAL MEMBRANE"
      }
    ],
    diagMac: [
      {
        value: "Not Tested",
        title: null,
        searchLabel: null,
        group: "Technical"
      },
      {
        value: "Poor Image Quality",
        title: null,
        searchLabel: null,
        group: "Technical"
      },

      {
        value: "Macular Pigment Clumping",
        title: "Macular Pigment Clumping",
        searchLabel: "Follow for any changes",
        group: "AMD"
      },
      {
        value: "Atrophy in Macula",
        title: "Macular Atrophy",
        searchLabel: "Follow for any changes",
        group: "AMD"
      },
      {
        value: "Pig Cl/Atrophy/Drusen/No Ret Thick",
        title: "Non-Exudative Macular Degeneration",
        searchLabel: "Follow for any changes",
        group: "AMD"
      },
      {
        value: "Pig Cl/Atrophy/Drusen/Ret Thick",
        title: "Exudative Macular Degeneration: Active",
        searchLabel: "Follow-up Intravitreal Injection",
        group: "AMD"
      },
      {
        value: "Pig Cl/Atrophy/Drusen/Ret Thick/SRF",
        title: "Exudative Macular Degeneration: Active",
        searchLabel: "Follow-up Intravitreal Injection",
        group: "AMD"
      },
      {
        value: "Pig Cl/Atrophy/Drusen/Retinal Thick/SRH",
        title: "Exudative Macular Degeneration: Active",
        searchLabel: "Follow-up Intravitreal Injection",
        group: "AMD"
      },
      {
        value: "SubMacular Hemorrhage",
        title: "Exudative Macular Degeneration: Active",
        searchLabel: "Follow-up Intravitreal Injection",
        group: "AMD"
      },

      {
        value: "Retinal Straightening",
        title: "Epiretinal Membrane",
        searchLabel: "Follow-up for further evaluation and possible treatment",
        group: "EPIRETINAL MEMBRANE"
      },
      {
        value: "Ret Folds/Straightening",
        title: "Epiretinal Membrane",
        searchLabel: "Follow-up for further evaluation and possible treatment",
        group: "EPIRETINAL MEMBRANE"
      },
      {
        value: "Ret Folds/Straight/ERM",
        title: "Epiretinal Membrane",
        searchLabel: "Follow-up for further evaluation and possible treatment",
        group: "EPIRETINAL MEMBRANE"
      },

      {
        value: "Macular Hole",
        title: "Macular Hole",
        searchLabel: "Follow-up for further evaluation and possible treatment",
        group: "OTHER"
      },
      {
        value: "Macular Thinning",
        title: "Macular Atrophy",
        searchLabel: "Follow for any signs of progression",
        group: "OTHER"
      },
      {
        value: "Cystic",
        title: "Cystic",
        searchLabel: null,
        group: "OTHER"
      }
    ],

    //////////////////////////////
    //  OPTIC NERVE OCT          /
    //////////////////////////////
    diagNrvCommon: [
      {
        value: "Normal",
        title: null,
        searchLabel: null,
        group: null
      },
      {
        value: "Thinning of the Nerve",
        title: "Glaucoma/Glaucoma Suspect",
        searchLabel: "Follow-up for further evaluation",
        group: null
      },
      {
        value: "Increased Cupping",
        title: "Glaucoma/Glaucoma Suspect",
        searchLabel: "Follow-up for further evaluation",
        group: null
      },
      {
        value: "Asymmetric Cupping",
        title: "Glaucoma/Glaucoma Suspect",
        searchLabel: "Follow-up for further evaluation",
        group: null
      },
      {
        value: "Swelling",
        title: "Optic Nerve Swelling",
        searchLabel: "Follow-up for Optic Nerve Swelling",
        group: null
      }
    ],
    diagNrv: [
      {
        value: "Not Tested",
        title: null,
        searchLabel: null,
        group: "Technical"
      },
      {
        value: "Poor Image Quality",
        title: null,
        searchLabel: null,
        group: "Technical"
      }
    ]
  }
}

const getters = {
  // API GETTERS
  omniDiag: (state) => (photo) => {
    if (!photo) return null
    switch (photo) {
      case "External":
        return state.findings.filter((o) => o.section == "ExternalPhoto")
      case "Cornea":
        return state.findings.filter((o) => o.section == "CornealTopography")
      case "Pachymetry":
        return state.findings.filter((o) => o.section == "AnteriorSegmentOCT")
      case "Opacity":
        return state.findings.filter((o) => o.section == "LensStatus")
      case "Fundus":
        return state.findings.filter((o) => o.section == "FundusPhoto")
      case "Macula":
        return state.findings.filter((o) => o.section == "MacularOCT")
      case "Nerve":
        return state.findings.filter((o) => o.section == "OpticNerveOCT")
    }
  },

  // ICD10_OD: (state) => (search) => {
  //   return state.ICD10.filter(o => o.Diagnosis.includes("right") && o.Diagnosis.includes(search));
  // },

  ICD10_OD: (state) => {
    return state.ICD10.filter((o) => o.Diagnosis.includes("right"))
  },

  ICD10_OS: (state) => {
    return state.ICD10.filter((o) => o.Diagnosis.includes("left"))
  },

  findingsMaxID: (state) => {
    return state.findingsMaxID
  },
  FindingID: (state) => {
    return state.newFindingID
  },
  StateFindings: (state) => {
    return state.findings
  },

  // STATIC GETTERS
  ddDiagExt: (state) => {
    return state.ddValues.diagExt
  },
  ddDiagExtComm: (state) => {
    return state.ddValues.diagExtCommon
  },
  ddDiagCor: (state) => {
    return state.ddValues.diagCor
  },
  ddDiagCorComm: (state) => {
    return state.ddValues.diagCorCommon
  },
  ddDiagPac: (state) => {
    return state.ddValues.diagPac
  },
  ddDiagPacComm: (state) => {
    return state.ddValues.diagPacCommon
  },
  ddDiagOpa: (state) => {
    return state.ddValues.diagOpa
  },
  ddDiagOpaComm: (state) => {
    return state.ddValues.diagOpaCommon
  },
  ddDiagFun: (state) => {
    return state.ddValues.diagFun
  },
  ddDiagFunComm: (state) => {
    return state.ddValues.diagFunCommon
  },
  ddDiagMac: (state) => {
    return state.ddValues.diagMac
  },
  ddDiagMacComm: (state) => {
    return state.ddValues.diagMacCommon
  },
  ddDiagNrv: (state) => {
    return state.ddValues.diagNrv
  },
  ddDiagNrvComm: (state) => {
    return state.ddValues.diagNrvCommon
  },
  findingsMetrics: (state) => {
    return state.findingsMetrics
  },

  // findings getters
  getSelectedFindings: (state) => {
    return state.selectedFindings
  }
}

// Called from Action to change State
const mutations = {
  updateSelectedFindings(state, payload) {
    const { section, ids } = payload
    state.selectedFindings[section] = ids
  },
  getScreenings(state, screenings) {
    state.screenings = screenings
  },

  commitFindings(state, findings) {
    state.findings = findings
  },

  calcMaxFindingsID(state) {
    let maxID = 0
    state.findings.forEach((finding) => {
      if (finding.id > maxID) {
        maxID = finding.id
      }
    })
    state.findingsMaxID = maxID
  },
  commitICD10(state, icd10_Codes) {
    state.ICD10 = icd10_Codes
  }
}

// Called externally to commit a State Mutation
const actions = {
  marshalFindings({ commit }, id) {
    return new Promise((resolve, reject) => {
      const url = state.baseURL + state.route_Findings
      const config = { headers: { "Content-Type": "application/json" }, params: { limit: 0 } }

      window.axios.get(url, config).then((response) => {
        resolve(response.data)
        commit("commitFindings", response.data)
        commit("calcMaxFindingsID")
      })
    })
  },

  marshalICD10({ commit }, id) {
    return new Promise((resolve, reject) => {
      const url = state.baseURL + state.route_ICD10
      const config = { headers: { "Content-Type": "application/json" } }
      const data = null

      window.axios.get(url, data, config).then((response) => {
        resolve(response.data)
        commit("commitICD10", response.data)
      })
    })
  },

  addFinding({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const url = state.baseURL + "/dbfindings/"
      const config = { headers: { "Content-Type": "application/json" } }
      const data = payload

      window.axios.post(url, data, config).then((response) => {
        response.data.id = state.newFindingID
        resolve(response.data)
      })
    })
  },
  updateSelectedFindingsIds({ commit }, payload) {
    commit("updateSelectedFindings", payload)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
